import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getBriefingToken } from '../../utils/briefingIntent';

export default function StartBriefing() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <main aria-busy="true">Preparing your briefing…</main>;
  if (isAuthenticated) return <Navigate to="/auth/continue" replace />;
  if (getBriefingToken()) return <Navigate to="/register" replace />;
  return <main style={{ margin: '10vh auto', maxWidth: 480, padding: 24 }}>
    <h1>Your briefing link is missing or expired</h1>
    <p><a href="https://lazysem.com/features/briefing">Enter your details again</a> to continue.</p>
    <p><a href="/login">Sign in to an existing account</a></p>
  </main>;
}
